export const MODAL_NAME = 'orders.ship'

export const IMEI_MAX_LENGTH = 15

export const FORM_ID = 'orders.ship'
